const state = {
  feature: null,
  activeLayer: null,
  raster: null,
}

const getters = {
  getFeature: state => state.feature,
  getActiveLayer: state => state.activeLayer,
  getRaster: state => state.raster,
}

const mutations = {
  setFeature (state, feature) {
    state.feature = feature
  },
  setActiveLayer (state, layer) {
    state.activeLayer = layer
  },
  setRaster (state, raster) {
    state.raster = raster
  },
}

const actions = {
  setFeature ({ commit }, feature) {
    commit('setFeature', feature)
  },
  setActiveLayer ({ commit }, layer) {
    commit('setActiveLayer', layer)
  },
  setRaster ({ commit }, raster) {
    commit('setRaster', raster)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
